export default [
  {
    label: 'Unknown', value: 'Unknown',
  },
  {
    label: '$0 to $50,000', value: '$0 to $50,000',
  },
  {
    label: '$50,001 to $100,000', value: '$50,001 to $100,000',
  },
  {
    label: '$100,001 to $500,000', value: '$100,001 to $500,000',
  },
  {
    label: '$500,001 to $1 million', value: '$500,001 to $1 million',
  },
  {
    label: '$1,000,001 to $10 million', value: '$1,000,001 to $10 million',
  },
  {
    label: '$10,000,001 to $50 million', value: '$10,000,001 to $50 million',
  },
  {
    label: '$50,000,001 to $100 million', value: '$50,000,001 to $100 million',
  },
  {
    label: '$100,000,001 to $500 million', value: '$100,000,001 to $500 million',
  },
  {
    label: '$500,000,001 to $1 billion', value: '$500,000,001 to $1 billion',
  },
  {
    label: 'More than $1 billion', value: 'More than $1 billion',
  },
  {
    label: '$1,000,000,001 to $10 billion', value: '$1,000,000,001 to $10 billion',
  },
  {
    label: '$10,000,000,001 to $50 billion', value: '$10,000,000,001 to $50 billion',
  },
  {
    label: 'More than $50 billion', value: 'More than $50 billion',
  },
];



// WEBPACK FOOTER //
// ./src/data/assetsAndLiabilities.js